// Re-syncs bloomreach-load-more controls after a bfcache restore (SM-542).
//
// This theme's cross-document view transitions mean popstate never fires for
// a back-navigation from a different document (e.g. a PDP) — see
// assets/scroll-container.js. Only pageshow does. Without this, a stale
// #host left over from before the page was frozen makes the button a
// silent no-op after such a back-navigation. connectToHost() is not
// private specifically so this file can call it.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  for (const control of document.querySelectorAll('bloomreach-load-more')) {
    if (typeof control.connectToHost === 'function') control.connectToHost();
  }
});
